import { environment } from '../../environments/environment';

export class Utils {
    public static URL_BACKEND = environment.BACKEND_URL; 

    static isMobile() {
        return window && window.matchMedia('(max-width: 767px)').matches;
    }
    static ngbDateToDate(ngbDate: { month, day, year }) {
        if (!ngbDate) {
            return null;
        }
        return new Date(`${ngbDate.month}/${ngbDate.day}/${ngbDate.year}`);
    }
    static dateToNgbDate(date: Date) {
        if (!date) {
            return null;
        }
        date = new Date(date);
        return { month: date.getMonth() + 1, day: date.getDate(), year: date.getFullYear() };
    }
    static datetoStringCode(date: Date) {
        if (!date) {
            return null;
        }
        date = new Date(date);
        var mes = ((date.getMonth() + 1).toString()).padStart(2, '0')
        var day = (date.getDate().toString()).padStart(2, '0')
        return date.getFullYear()+ mes + day 
    }
    static scrollToTop(selector: string) {
        if (document) {
            const element = <HTMLElement>document.querySelector(selector);
            element.scrollTop = 0;
        }
    }
    static genId() {
        let text = '';
        const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < 5; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    }
    static getUrlService(){
        return Utils.URL_BACKEND;
    }
}
